import { Component, OnInit } from '@angular/core';
import { RestService } from './service/rest.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

const SITE_NAME = 'Academy Of Arts';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'acadmia';
  faucltyArr: any
  list_condtion
  branches: any
  alex_branch
  main_branch
  buildingArr: any
  constructor(
    private rest: RestService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.homeapi()
    this.getBranches()
    this.handleRouteChanges()
  }

  // On every completed navigation: update the document title from the route's
  // `data.title` (2.4.2) and move keyboard focus to the new page's <main> so
  // screen-reader and keyboard users land on the fresh content (2.4.3).
  private handleRouteChanges() {
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let r = this.activatedRoute
        while (r.firstChild) { r = r.firstChild }
        const pageTitle = r.snapshot.data && r.snapshot.data.title
        this.titleService.setTitle(pageTitle ? `${pageTitle} | ${SITE_NAME}` : SITE_NAME)

        // Defer to let the new view render, then focus the main landmark.
        setTimeout(() => {
          const main = document.getElementById('mainContent')
          if (main) { main.focus() }
        }, 0)
      })
  }

  // Skip-to-content link target (2.4.1): move focus to the page's main content.
  skipToContent(event: Event) {
    event.preventDefault()
    const main = document.getElementById('mainContent')
    if (main) { main.focus() }
  }

  getBranches() {
    this.rest.GetBranchesFaculties().subscribe((res: any) => {
      console.log(res, "asds")
      const index1 = 0;
      const index2 = 5;
      this.buildingArr = res.academy_constructions
      const temp = this.buildingArr[index1];
      this.buildingArr[index1] = this.buildingArr[index2];
      this.buildingArr[index2] = temp;

      this.branches = res.branches
      for (let i = 0; i < this.branches.length; i++) {
        for (let j = 0; j < this.branches[i].faculty.length; j++) {
          this.branches[i].faculty[j].branch_id = this.branches[i].branch_id
        }
      }
      this.alex_branch = this.rest.orderFaculties(this.branches[1].faculty)
      this.main_branch = this.rest.orderFaculties(this.branches[0].faculty)
    })
  }

  homeapi() {
    this.rest.homePage().subscribe((res: any) => {
      this.faucltyArr = this.rest.orderFaculties(res.faculty)

    })
    this.rest.GetConditionsAndTerms().subscribe(res => {
      this.list_condtion = res
    })
  }

  gotToFaculty(item) {
    localStorage.setItem('FACULTY_NAME', item.FACULTY_NAME)
    localStorage.setItem("facultyId", item.ID)
    localStorage.setItem("DATE_ESTABLISH", item.DATE_ESTABLISH)
    localStorage.setItem("faculty_image", item.SLIDER_IMAGE)
    localStorage.setItem('branch_id', item.branch_id)
    this.openFacultySite(item)
  }

  // Every institute lives on its own subdomain and resolves itself from the
  // hostname, so we send the user to that subdomain. `path` lets callers land
  // on a specific page (e.g. '/register'); it defaults to the root. The
  // Alexandria branch (branch_id 6) has separate "-alx" subdomains.
  openFacultySite(item, path = '/') {
    const mainBranch = {
      8: 'himc', 11: 'hib', 12: 'hic', 13: 'hita', 14: 'hiam',
      15: 'hifa', 16: 'hiac', 17: 'hica', 19: 'hialamt'
    }
    const alexBranch = {
      12: 'hic-alx', 13: 'hita-alx', 16: 'hiac-alx', 15: 'hifa-alx'
    }
    const map = (item.branch_id == 6) ? alexBranch : mainBranch
    const sub = map[item.ID]
    if (sub) {
      window.location.href = 'https://' + sub + '.aoa.edu.eg' + path
    }
  }
  gotToConstrction(item) {
    // Mapped activities live on their own subdomain; send the user there.
    // Anything without a subdomain still falls back to in-app id routing.
    if (this.rest.constructionSubdomains[item.ID]) {
      this.rest.openConstructionSite(item)
      return
    }
    this.route.navigate(['/constrction', item.ID]).then(() => {
      location.reload()
    })
  }

  faculty_id = ''
  branch_status = false
  selectOption(event) {
    this.branch_status = true
    if (event.target.value == '1') {
      this.faucltyArr = this.main_branch
    } else {
      this.faucltyArr = this.alex_branch
    }

  }
  selectedFaculty: any = null
  selectOptionFaculty(event) {
    this.faculty_id = event.target.value
    this.selectedFaculty = (this.faucltyArr || []).find(f => f.ID == this.faculty_id)
  }

  // From the "القبول والتسجيل" modal: open the chosen institute's own subdomain
  // straight on its /register page (the institute is resolved from the hostname
  // there, so no id needs to be passed along).
  go_faculty() {
    if (this.selectedFaculty) {
      this.openFacultySite(this.selectedFaculty, '/register')
    }
  }




}
